// React imports.
import React, { Component } from "react";
const SelectedDataFields = ({ fields, toggleFieldSelected }) => (
  <div className="verticalList" >
    {fields
      .filter(f => f.tableFieldSelected)
      .map(field => {
        return (
          <label key={field.tableFieldId}
              data-tooltip={field.tableFieldTooltip}>
            <input type="checkbox" value={field.tableFieldId}
              checked={field.tableFieldSelected}
              onChange={e => toggleFieldSelected(field.tableFieldId)}/>
              <span >{field.tableFieldDescription}</span>
          </label>
        );
    })}
  </div>
);

export default SelectedDataFields;
